<app-stepper
  [nextStepDisabled]="viewInitialized ? nextStepDisabled() : true"
  [nextLoading]="viewInitialized ? isNextLoading() : false"
  [previousLoading]="viewInitialized ? isPreviousLoading() : false"
  [cancelLoading]="viewInitialized ? isCancelLoading() : false"
  [draftOrSubmitLoading]="viewInitialized ? isDraftOrSubmitLoading() : false"
  (nextEvent)="nextStep()"
  (previousEvent)="previousStep()"
  (cancelEvent)="cancelOrder()"
  (draftOrSubmitEvent)="draftOrSubmitOrder()">
  <cdk-step
    label="{{ 'Stepper.Order_Information' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.OrderInfo)">
    <app-order-info /></cdk-step>
  <cdk-step
    label="{{ 'Stepper.Billing_Information' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.BillingInfo)">
    <app-billing-info /></cdk-step>
  <cdk-step
    label="{{ 'Stepper.Patient_Information' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.PatientInfo)">
    <app-patient-info /></cdk-step>
  <cdk-step
    label="{{ 'Stepper.Clinical_History' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.ClinicalHistory)">
    <app-clinical-info /></cdk-step>
  <cdk-step
    label="{{ 'Stepper.Informed_Consent' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.ConsentInfo)">
    <app-consent-info /></cdk-step>
  <cdk-step
    label="{{ 'Stepper.Confirm_Order' | translate }}"
    [completed]="getOrderStepStatus(checkoutStep.ConfirmOrder)">
    <app-order-confirm /></cdk-step>
</app-stepper>
